import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";
import toast from "react-hot-toast";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Tag } from "../../lib/types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  currentTagIds: number[];
  illustrationId: string;
  onUpdate: () => void;
};

export const TagSelectModal = ({
  isOpen,
  onClose,
  currentTagIds,
  illustrationId,
  onUpdate,
}: Props) => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>(currentTagIds);

  useEffect(() => {
    const fetchAllTags = async () => {
      try {
        const data = await apiClient.get("/tags") as Tag[];
        setTags(data || []);
      } catch (error) {
        toast.error("タグの取得に失敗しました");
      }
    };

    if (isOpen) {
      fetchAllTags();
      setSelectedTagIds(currentTagIds || []);
    }
  }, [isOpen, currentTagIds]);

  const handleSave = async () => {
    try {
      const illustration = await apiClient.get(`/illustrations/${illustrationId}`);

      await apiClient.patch(`/illustrations/${illustrationId}`, {
        ...illustration,
        tag_ids: selectedTagIds
      });

      onUpdate();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("保存に失敗しました");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">タグを選択</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-2">
          {tags.map((tag) => (
            <label key={tag.id} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={selectedTagIds.includes(tag.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedTagIds([...selectedTagIds, tag.id]);
                  } else {
                    setSelectedTagIds(
                      selectedTagIds.filter((id) => id !== tag.id)
                    );
                  }
                }}
                className="rounded"
              />
              <span>{tag.tag}</span>
            </label>
          ))}
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded"
          >
            キャンセル
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm bg-blue-600 text-white hover:bg-blue-700 rounded"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  );
};
